export const links = {
  MAIN: "/",
  MULTI_COUPONS: "/multi-coupons",
  LOGIN: "/login",
  LIFF_LOGIN: "/login/line-liff",
  RESEND: "/resend-message",
  EARN_PAGE: "/earn-rewards",
  ENGAGE_PAGE: "/engage/:id",
  USE_REWARD: "/use-reward/:id",
  USE_REWARD_V2: "/use-reward", // USE_REWARD, USE_REWARD_V2, COUPON are duplicate of the layout components
  COUPON: "/coupon/:id", // id refer to coupon_reference of app_coupondetail of coupon used by Anonymous Credit Distribution sub campaign
  VERIFY: "/verify-registration/:base64",
  GETURL: "/verify/:id",
  DAGC: "/dagc/:id",
  DOWNLOAD: "/download/:app_name",
  ENGAGED_PAGE: "/engaged",
  OTP_INSERT_PHONE_NUMBER: "/otp/insert-phone-number",
  OTP_INSERT_OTP: "/otp/insert-otp",
  OTP_PAGE_EXPIRED: "/otp/page-expired",
  OTP_MAX_ATTEMPT_REACHED: "/otp/maximum-attempts-reached",
  OTP_PHONE_NUMBER_ALREADY_REGISTERED: "/otp/phone-number-already-registered",
  SMART_RETAIL_STATUS: "/smart-retail-status/success",
  SMART_RETAIL_ERROR: "/smart-retail-status/error",
  VALIDATE_ENGAGE_FIRST: "/validate-engage-first/:engage_session",
  CAMPAIGN_STATUS: "/campaign-status/:status",
  VERSION: "/version",
  CAMPAIGN_LIMIT_ERROR: "/campaign-limit-error",
  SE_RECEIPT: "/se-receipt",
  LOYALTY_SUBMIT: "/loyalty-submit",
  LIST_PAGE: "/list/:id",
  PAY_PAY_CONSENT: "/pay-pay-consent",
  PAY_PAY_COUPON: "/pay-pay-coupon"
};
